'use strict';

exports.__esModule = true;

var _domElements = require('../utils/domElements');

var _domElements2 = _interopRequireDefault(_domElements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Target = require('../types').babelPluginFlowReactPropTypes_proptype_Target || require('prop-types').any;

exports.default = function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  _domElements2.default.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/constructors/styled.js
// module id = 2896
// module chunks = 14